/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlEntityAssetDomainSource = {
    RootDomain: 'root-domain',
    SubdomainEnumeration: 'subdomain-enumeration'
} as const;
export type ControlEntityAssetDomainSource = typeof ControlEntityAssetDomainSource[keyof typeof ControlEntityAssetDomainSource];


export function ControlEntityAssetDomainSourceFromJSON(json: any): ControlEntityAssetDomainSource {
    return ControlEntityAssetDomainSourceFromJSONTyped(json, false);
}

export function ControlEntityAssetDomainSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityAssetDomainSource {
    return json as ControlEntityAssetDomainSource;
}

export function ControlEntityAssetDomainSourceToJSON(value?: ControlEntityAssetDomainSource | null): any {
    return value as any;
}

